import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import SessionSection from "./components/SessionSection";
import AboutSection from "./components/AboutSection";
import MethodSection from "./components/MethodSection";
import ConsultationsSection from "./components/ConsultationsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import ScrollToTop from "./components/ScrollToTop";

const AppLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#F5F0E8]">
      <Header />
      {children}
      <Footer />
    </div>
  );
};

const Home = () => {
  return (
    <AppLayout>
      <HeroSection />
      <SessionSection />
      <AboutSection />
      <MethodSection />
      <ConsultationsSection />
      <ContactSection />
    </AppLayout>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/mentions-legales"
            element={
              <AppLayout>
                <MentionsLegales />
              </AppLayout>
            }
          />
          <Route
            path="/politique-confidentialite"
            element={
              <AppLayout>
                <PolitiqueConfidentialite />
              </AppLayout>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
